module.exports = {
  App: {
    Agreement: 'Пожалуйста, прочтите и примите Пользовательское соглашение'
  }
}
